import { formatTimeString } from '../../utils/formatters'
import BaseExporter from './base_exporter'

export default class AccreditationStatusesExporter extends BaseExporter {
  export() {
    const data = this.data.map((entry) => {
      const dataRow = []
      if (!entry) {
        return new Array(this.header.length)
      }
      dataRow.push(entry.id)
      dataRow.push(entry.status)
      dataRow.push(entry.identity ? `${entry.identity.first_name} ${entry.identity.last_name}` : '')
      dataRow.push(entry.message)
      dataRow.push(formatTimeString(entry.created))
      dataRow.push(formatTimeString(entry.updated))

      return dataRow
    })

    data.unshift(this.header)
    return data
  }
}
